import { Component, OnInit } from '@angular/core';
import {PageService} from "../../services/page.service";
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.css']
})
export class PagesComponent implements OnInit {

  constructor(private pService:PageService,private route: ActivatedRoute,
      private router: Router) { }

  pageUrl:any;
  pageTitle:any;
  pageContent:any;

  ngOnInit() {
  	// this.pageUrl = this.route.snapshot.paramMap.get('pid');
   //  this.pService.getSupportPage(this.pageUrl).subscribe((result:any)=>{
   //    this.pageTitle = this.menu[this.pageUrl];
   //    this.pageContent = result;
   //  })
  	// this.route.params.subscribe( params => {
   //    this.pService.getSupportPage(params.pid).subscribe((result:any)=>{
   //      this.pageTitle = this.menu[params.pid];
   //    	this.pageContent = result;
   //    })
   //  });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/pages/pages.component.ts